module.exports = __webpack_public_path__ + "img/tako.00f11c31.jpg";